import React, { useState, useEffect, useRef } from 'react';
import TR from './../../Trans';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import 'video.js/dist/video-js.css';
import SearchField from './../items/SearchField';
import TrackListScroller from './../items/TrackListScroller';
import LinearProgressWithLabel from '../items/LinearProgressWithLabel';
import Popover from '@mui/material/Popover';
import { Capacitor } from '@capacitor/core';
import Stack from '@mui/material/Stack';
import ContentContainer from './../items/ContentContainer';
import FormControlLabel from '@mui/material/FormControlLabel';
import SvgIcon from '@mui/material/SvgIcon';
import Checkbox from '@mui/material/Checkbox';
import sessionStore from './../../stores/session';
import bgSearchStore from '../../stores/bgSearch';
import messageStore from '../../stores/message';
import accountStore from '../../stores/account';

function BgSearch() {

  const itemsOnPage = 25;
  const sessionToken = sessionStore((state) => state.sessionToken);
  const isWaiting = bgSearchStore((state) => state.isWaiting);
  const totalCount = bgSearchStore((state) => state.totalCount);
  const tracks = bgSearchStore((state) => state.tracks);
  const searchQuery = bgSearchStore((state) => state.searchQuery);
  const setSearchQuery = bgSearchStore((state) => state.setSearchQuery);
  const search = bgSearchStore((state) => state.search);
  const searchMore = bgSearchStore((state) => state.searchMore);
  const isFinished = bgSearchStore((state) => state.isFinished);
  const fieldTitle = bgSearchStore((state) => state.fieldTitle);
  const fieldArtist = bgSearchStore((state) => state.fieldArtist);
  const toggleFieldTitle = bgSearchStore((state) => state.toggleFieldTitle);
  const toggleFieldArtist = bgSearchStore((state) => state.toggleFieldArtist);
  const setError = messageStore((state) => state.setError);
  const setResetArtistSearchMode = bgSearchStore((state) => state.setResetArtistSearchMode);
  const isArtistSearchMode = bgSearchStore((state) => state.isArtistSearchMode);
  const accountLang = accountStore((state) => state.account?.language);

  useEffect(() => { }, [accountLang]);

  const ref = useRef(null);

  useEffect(() => {
    if (ref) {
      if (ref.current) {

        ref.current.value = searchQuery;
      }
    }
  }, [searchQuery]);

  let [changedSearchQuery, setChangedSearchQuery] = useState(searchQuery);

  const handleSearchQueryChange = (e) => {
    setChangedSearchQuery(e.target.value);
    if (isArtistSearchMode) {
      setResetArtistSearchMode();
    }
  };

  const handleScrollDown = () => {
    searchMore(sessionToken, itemsOnPage);
  };

  const scrollToTop = () => {
    const element = document.getElementById('music-search-tracklist');
    if (element) {
      element.scrollTop = 0;
    }
  };

  const onSearch = () => {
    if (changedSearchQuery.length > 1) {
      setSearchQuery(changedSearchQuery);
      search(sessionToken, itemsOnPage);
      scrollToTop();
      if (document.activeElement) {
        document.activeElement.blur();
      }
    } else {
      setError(sessionToken, 0, TR.cm_seach_text_too_short);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  const handleSearch = () => {
    onSearch();
  };

  const handleFieldTitle = () => {
    toggleFieldTitle();
  };

  const handleFieldArtist = () => {
    toggleFieldArtist();
  };

  const createPlaceholder = () => {
    if (fieldArtist && !fieldTitle) {
      return TR.cm_song_artist_or_code;
    } else if (fieldTitle && !fieldArtist) {
      return TR.cm_song_title_or_code;
    } else {
      return TR.cm_song_title_artist_or_code;
    }
  };

  const handleSearchClear = () => {
    if (ref.current) {
      ref.current.value = "";
    }
  };

  const renderTotalCount = () => {
    if (tracks) {
      return <p>
        {TR.cm_total}: {totalCount}
      </p>;
    }
    return <p>&nbsp;</p>;
  };

  return (
    <div>
      <h3>{TR.cm_bg_search}</h3>
      <SearchField id="muvika-bg-search-field" isBackgroundMusic={true} onref={ref} onClear={handleSearchClear} placeholder={createPlaceholder()} className={"muvika-container-search-field"} value={searchQuery} onSearchQueryChange={handleSearchQueryChange} onSearch={handleSearch} onKeyDown={handleKeyDown} />
      <p>
        <FormControlLabel onChange={handleFieldTitle} control={<Checkbox checked={fieldTitle} />} label={TR.cm_song_title} />
        <FormControlLabel onChange={handleFieldArtist} control={<Checkbox checked={fieldArtist} />} label={TR.cm_artist} />
      </p>
      {renderTotalCount()}
      <TrackListScroller isBackgroundMusic={true} isWaiting={isWaiting} id="music-search-tracklist" isFinished={isFinished} tracks={tracks} onScrollDown={handleScrollDown} />
    </div>
  );
}

export default BgSearch;